import React from "react";

export default () => (
    <React.Fragment>
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
                __html: JSON.stringify(
                    {
                        "@context": "http://schema.org",
                        "@type": "HotelRoom",
                        "name": "Family Suite",
                        "url": "https://www.hoteltwintowers.com/hotel-room-in-shimla/family-suite-room",
                        "image": "https://www.hoteltwintowers.com/images/family-banner.png",
                        "description": "Our 650-square-feet Family Suite has a classic design and a picturesque view of the mountains. All the amenities you might want are there, from a walk-in wardrobe to king-sized beds to a minibar to an electric safe to Wi-Fi to LED televisions to contemporary bathrooms with luxurious toiletries to electronic key entrance and more. The special amenities in this room category are here to make your stay more enjoyable and productive making it the best family suite in Kufri.",
                        "containedInPlace": {
                            "@type": "Place",
                            "name": "The Twin Towers Hotel",
                            "url": "https://hoteltwintowers.com/",
                            "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "NH 05, New kufri, Galu, Hills,",
                                "addressLocality": "Shimla",
                                "addressRegion": "Indian Himalayan Region",
                                "postalCode": "171209",
                                "addressCountry": "India"
                            }
                        },
                        "bed": {
                            "@type": "BedDetails",
                            "numberOfBeds": 2
                        },
                        "occupancy": {
                            "@type": "QuantitativeValue",
                            "maxValue": "2"
                        },
                        "amenityFeature": [
                            {
                                "@type": "LocationFeatureSpecification", "value": "True", "name": "City Views"
                            },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "Balcony" },
                            { "@type": "LocationFeatureSpecification", "value": "True", "name": "King Size Bed" }
                        ]
                    }

                )
            }}
        />
    </React.Fragment>
);
